import "./App.css";
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { NavBar } from "./components/NavBar";
import { Footer } from "./components/Footer";

import { Home } from "./components/Home";
import { About } from "./components/About";
import { Meditation } from "./components/Meditation";
import { Channeling } from "./components/Channeling";
import { Passage } from "./components/Passage";
import { Nouveau } from "./components/Nouveau";

import { Musique } from "./components/Musique";
import { Remerciements } from "./components/Remerciements";
import { FAQ } from "./components/FAQ";
import { Auteure } from "./components/Auteure";
import { NouveauLivre } from "./components/NouveauLivre";
import { Contact } from "./components/Contact";
import { Mentions } from "./components/Mentions";
import { Mathis } from "./components/Mathis";
import { Louna } from "./components/Louna";
import { Ilyes } from "./components/Ilyes";
import { BebeBouleDeJoie } from "./components/BebeBouleDeJoie";
import { ContesMeditatifs } from "./components/ContesMeditatifs";

import { NotFound } from "./components/NotFound";

import ScrollToTop from "./components/ScrollToTop";

import { SocialBar } from "./components/SocialBar";

function App() {
  return (
    <Router>
      <div>
        <NavBar />
        <div className="content-container">
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/meditation" element={<Meditation />} />
            <Route path="/channeling" element={<Channeling />} />
            <Route path="/passage-d-ames" element={<Passage />} />
            <Route path="/accueil-nouveaux-nes" element={<Nouveau />} />
            <Route path="/musique" element={<Musique />} />
            <Route path="/remerciements" element={<Remerciements />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/auteure" element={<Auteure />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/musique" element={<Musique />} />
            <Route path="/mentions" element={<Mentions />} />
            <Route path="/accueil-nouveaux-nes/mathis" element={<Mathis />} />
            <Route path="/accueil-nouveaux-nes/louna" element={<Louna />} />
            <Route path="/accueil-nouveaux-nes/ilyes" element={<Ilyes />} />
            <Route
              path="/accueil-nouveaux-nes/bebe-boule-de-joie"
              element={<BebeBouleDeJoie />}
            />
            <Route path="/contes-meditatifs" element={<ContesMeditatifs />} />
            <Route path="/nouveau-livre" element={<NouveauLivre />} />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
        <Footer />
        <SocialBar />
      </div>
    </Router>
  );
}

export default App;
